import { useQuery } from "@tanstack/react-query";
import type { FunnelPromptFields, FunnelDTO } from "@ai-crm/shared";
import { PromptEditor } from "@ai-crm/agent-ui";
import { adminApi } from "../lib/api";
export function AdminPromptEditor({
  token,
  accountId,
  value,
  onChange,
  fields,
  onFieldsChange,
  disabled = false,
}: {
  token: string;
  accountId: string;
  value: string;
  onChange: (value: string) => void;
  fields: FunnelPromptFields;
  onFieldsChange: (fields: FunnelPromptFields) => void;
  disabled?: boolean;
}) {
  const capabilities = useQuery({
    queryKey: ["admin", "prompt-capabilities", accountId],
    queryFn: () => adminApi.promptCapabilities(token, accountId),
    enabled: !!accountId,
  });
  const agents = useQuery({
    queryKey: ["admin", "account", accountId, "prompt-sources"],
    queryFn: () => adminApi.accountFunnels(token, accountId),
    enabled: !!accountId && !!capabilities.data?.promptEditorEnabled,
  });
  if (!capabilities.data?.promptEditorEnabled)
    return (
      <label className="text-sm font-medium">
        <span className="mb-1.5 block">Системный промпт</span>
        <textarea
          className="control min-h-40"
          maxLength={10000}
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        />
      </label>
    );
  // Only the source's main/block are copied; action permissions never enter this adapter.
  const sources: FunnelDTO[] = (agents.data ?? []).map((agent) => ({
    ...agent,
    allowLeadUpdates: agent.allowLeadUpdates ?? false,
    allowContactUpdates: agent.allowContactUpdates ?? false,
    escalateOnGoal: agent.escalateOnGoal ?? false,
    goalStatusId: agent.goalStatusId ?? null,
    outcomeCriteriaStatus: agent.outcomeCriteriaStatus ?? "PENDING",
    escalationEnabled: agent.escalationEnabled ?? false,
    escalationStatusId: agent.escalationStatusId ?? null,
    capabilitiesVersion: agent.capabilitiesVersion ?? 1,
    channels: [],
    model: agent.model,
  }));
  return (
    <PromptEditor
      value={value}
      onChange={onChange}
      fields={fields}
      onFieldsChange={onFieldsChange}
      disabled={disabled}
      agents={sources}
      loadAgent={(id) => adminApi.funnel(token, id)}
      generate={(input, signal) =>
        adminApi.generatePromptCandidate(token, accountId, input, signal)
      }
      generateEscalation={(input, signal) =>
        adminApi.generateEscalation(token, accountId, input, signal)
      }
    />
  );
}
